import axios from "axios";
import WriteToLog from "./WriteToLog";  

/**
 * Save data to EHR
 * @param {*} patID 
 * @param {*} encID 
 * @param {*} ehrID 
 * @param {*} value 
 * @param {*} userID 
 * @param {*} fhir_server 
 * @param {*} access_token 
 * @returns 
 */
async function saveData(patID, encID, ehrID, value, userID, fhir_server, access_token) {
  let setEHRResponse = "";
  var ehrValue = value;
  const ehrconfig = await axios.get('ehrconfig.json');
  //WriteToLog("Value to save in EHR: " + ehrValue);

  const _epicWSHeaders = {
    'Authorization': 'Bearer ' + access_token,
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };

  let setDataUrl = fhir_server + ehrconfig.data["EHR_SAVE_DATA"];

  let data = { 
    'ContextName': (encID === '99999' ? 'patient' : 'encounter'),
    'EntityID': patID,
    'EntityIDType': 'External',
    'ContactID': encID,
    'ContactIDType': (encID === '99999' ? 'DAT' : 'CSN'),
    'UserID': userID,
    'UserIDType': 'External',
    'Source': 'CHOP Airway Bundle Checklist',
    SmartDataValues: [{
      SmartDataID: ehrID,
      SmartDataIDType: 'SDI',
      Values: [ehrValue],
      Comments: []
    }]
  };

  try {
    const response = await axios.put(setDataUrl, data, { headers: _epicWSHeaders });
    if (response.data !== undefined) {
      //WriteToLog("saveData response data: " + JSON.stringify(response.data));
      let ehrsuccess = JSON.stringify(response.data.Success);
      if (ehrsuccess === "true") {
        setEHRResponse = "success"; 
      } else {
        setEHRResponse = "failed";
      }
    }  
    return setEHRResponse;

  } catch (error) {
    if (error.response) {
      if (error.response.status !== 401) { // 401 - Access Token Expired
        WriteToLog("saveData error.response: " + JSON.stringify(error.response.status));
      }
    } else if (error.request) {
      WriteToLog("saveData error.request: " + error.request);
    } else {
      WriteToLog('saveData error ', error.message);
    }
    return setEHRResponse;  
  }  
}

export default saveData;
